var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$apollo.queries.eventCategories.loading
    ? _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", color: "primary" },
          }),
        ],
        1
      )
    : _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "PageContent",
            { attrs: { height: "100", padding: "0px 10px 0px 0px" } },
            [
              _c(
                "v-list",
                { staticStyle: { background: "unset" }, attrs: { dense: "" } },
                [
                  _c(
                    "v-row",
                    _vm._l(_vm.navItems, function (navItem, navItemIndex) {
                      return _c(
                        "v-col",
                        {
                          key: `${navItemIndex}-${navItemIndex}`,
                          attrs: { cols: "4" },
                        },
                        [
                          _c(
                            "v-card",
                            _vm._b(
                              { attrs: { to: navItem.to || null } },
                              "v-card",
                              _vm.$options.cardStyle,
                              false
                            ),
                            [
                              _c("v-card-text", {
                                staticClass: "text-center text-h5",
                                domProps: { textContent: _vm._s(navItem.text) },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }